import { BtnClasses, IconButton } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { DropdownSelect } from '@trimble/ui-components/solidjs';
import { Component, Show } from 'solid-js';

import { FX_REFERENCES_FILTER_OPTIONS } from '../selections/tree/filter-fx-reference-nodes';
import { fxWorkspaceDropdownSlotClass } from './fx-workspace-dropdown-slot-class';
import type {
  WorkspacesTabHeaderControlsProps,
  WorkspacesTabWorkspaceActionsProps,
} from './WorkspacesTabHeaderControls.types';

export const WorkspacesTabReferencesFilter: Component<
  Pick<
    WorkspacesTabHeaderControlsProps,
    'referencesFilterMode' | 'onReferencesFilterChange'
  >
> = (props) => (
  <div
    class={fxWorkspaceDropdownSlotClass}
    data-testid="fx-references-filter-dropdown"
    aria-label={t('mobileMapping.fxWorkspace.references.filter.label')}
  >
    <DropdownSelect
      options={FX_REFERENCES_FILTER_OPTIONS()}
      value={props.referencesFilterMode}
      onValueChange={props.onReferencesFilterChange}
    />
  </div>
);

export const WorkspacesTabReferencesViewToggle: Component<
  Pick<
    WorkspacesTabHeaderControlsProps,
    | 'referencesViewToggleIcon'
    | 'referencesViewToggleTitle'
    | 'onReferencesViewToggle'
  >
> = (props) => (
  <IconButton
    color={BtnClasses.TERTIARY}
    icon={props.referencesViewToggleIcon}
    size="icon-medium"
    data-testid="fx-references-view-toggle"
    title={props.referencesViewToggleTitle}
    clicked={props.onReferencesViewToggle}
  />
);

export const WorkspacesTabWorkspaceActions: Component<
  WorkspacesTabWorkspaceActionsProps
> = (props) => (
  <Show when={props.hasActiveWorkspace}>
    <IconButton
      color={BtnClasses.TERTIARY}
      icon="tc-icon-content-add"
      size="icon-medium"
      data-testid="modify-workspace-data-button"
      title={t('mobileMapping.fxWorkspace.modifyWorkspaceData')}
      clicked={props.onModifyWorkspaceData}
    />
    <Show when={props.showDeleteWorkspace}>
      <IconButton
        color={BtnClasses.TERTIARY}
        icon="tc-icon-delete"
        size="icon-medium"
        data-testid="delete-workspace-button"
        title={t('mobileMapping.fxWorkspace.delete')}
        clicked={props.onDeleteWorkspace}
      />
    </Show>
  </Show>
);
